import { makeRequestWithRetry } from 'src/utils/graphql';
import { QUERY_BRAND_SPACES_LISTING } from '../queries';
import { RetailerEntity } from 'src/modules/retailer';

export const fetchBrandSpacesListingData = async (link: string) => {
  const response = await makeRequestWithRetry<{ stores: RetailerEntity[] }>(
    QUERY_BRAND_SPACES_LISTING,
    {},
    { errorId: 'fetchBrandSpacesListingData()' }
  );

  return { link, stores: response.stores };
};
